export default "__VITE_ASSET__e5a3695c__"